import axios from 'axios'
import { urlGenerator } from '@store/api'

// axios.defaults.baseURL = 'https://cms-sgmaster.sellon.net/'
// axios.defaults.baseURL = 'https://dev2-cms-sgmaster.sellon.net/'
axios.defaults.baseURL = 'https://cms-idmaster.sellon.net/'

export function getHomeData (payload) {
  const url = 'api_mobile/homepage/'
  const requestAPI = axios.request({
    url: urlGenerator(url, payload),
    method: 'get'
  })
  return requestAPI
}
export function getPostDiscovery (payload) {
  const url = 'api_mobile/community/'
  const requestAPI = axios.request({
    url: urlGenerator(url, payload),
    method: 'get'
  })
  return requestAPI
}
